import {
  ADD_CUSTOMER_HEAD_ERROR,
  ADD_CUSTOMER_HEAD_LOADING,
  ADD_CUSTOMER_HEAD_SUCCESS,
  CLEAR_CUSTOMER_HEAD_DATA,
} from "../Constants/CustomerHeadConstants";

export const AddCustomerHeadReducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_CUSTOMER_HEAD_LOADING:
      return { loading: true };
    case ADD_CUSTOMER_HEAD_SUCCESS:
      return { loading: false, customerHeadData: action.payload };
    case ADD_CUSTOMER_HEAD_ERROR:
      return { loading: false, error: action.payload };
    case CLEAR_CUSTOMER_HEAD_DATA:
      return { loading: false, error: false, customerHeadData: null };
    default:
      return state;
  }
};
